<template>
  <router-view></router-view>
</template>

<script>
export default {
	name: 'Tipos',
	title: 'Tipos'
}
</script>

<style scoped>
</style>
